"use strict";

/**
 * mobile-menu.js
 *
 * Handles toggling the mobile menu and subnav pages
 */

class MobileMenu {
  constructor() {
    this.elements = null;
    this.grabElements();
    if (this.elements.navigation.length) {
      this.bindEvents();
    }
  }
  grabElements() {
    this.elements = {
      body: jQuery('body'),
      menuTrigger: jQuery('.js-toggle-menu'),
      navigation: jQuery('.menu-primary-navigation-container'),
      subMenuToggle: jQuery('.js-submenu-trigger').not('.menu-item-button--close'),
      subMenuBack: jQuery('.js-submenu-trigger.menu-item-button--close')
    };
  }
  bindEvents() {
    this.elements.menuTrigger.on('click', this.handleToggleMenu.bind(this));
    this.elements.body.on('keydown', this.mobileKeyboardNavigation.bind(this));
  }
  toggleMobileAttrs() {
    this.elements.navigation.toggleClass('mobile-open');
    this.elements.menuTrigger.toggleClass('mobile-open');
    this.elements.menuTrigger.attr('aria-expanded', (_, attr) => !(attr === 'true'));
  }
  mobileKeyboardNavigation(e) {
    if (this.elements.navigation.hasClass('mobile-open')) {
      if (e.key === 'Escape') {
        // Close mobile menu and focus trigger
        this.toggleMobileAttrs();
        // eslint-disable-next-line no-undef
        bodyScrollLock.enableBodyScroll(this.elements.navigation);
        setTimeout(() => this.elements.menuTrigger.trigger('focus'), 200);
      } else if (e.key === 'Tab') {
        // Handle mobile keyboard navigation, keeping user confined to menu and trigger
        const allNavLinks = this.elements.navigation.find('.menu-item a');
        const firstNavLink = allNavLinks[0];
        const backTrigger = this.elements.subMenuBack;
        const allTopLevelSubMenus = this.elements.navigation.find('.main-navigation > .menu-item > .sub-menu');
        const lastLinksOnSubmenus = allTopLevelSubMenus.map(function () {
          return jQuery(this).find('> ul').children().last().find('a')[0];
        });
        const lastSubmenuTrigger = this.elements.subMenuToggle[this.elements.subMenuToggle.length - 1];
        if (!e.shiftKey) {
          if (lastLinksOnSubmenus.is(document.activeElement)) {
            e.preventDefault();
          } else if (document.activeElement === lastSubmenuTrigger && jQuery(lastSubmenuTrigger).attr('aria-expanded') !== 'true') {
            e.preventDefault();
            this.elements.menuTrigger.trigger('focus');
          } else if (document.activeElement === this.elements.menuTrigger[0]) {
            e.preventDefault();
            jQuery(firstNavLink).trigger('focus');
          }
        } else if (e.shiftKey) {
          if (document.activeElement === firstNavLink) {
            e.preventDefault();
            this.elements.menuTrigger.trigger('focus');
          } else if (backTrigger.is(document.activeElement)) {
            e.preventDefault();
          }
        }
      }
    }
  }
  handleToggleMenu() {
    this.toggleMobileAttrs();
    if (this.elements.navigation.hasClass('mobile-open')) {
      // eslint-disable-next-line no-undef
      bodyScrollLock.disableBodyScroll(this.elements.navigation, {
        allowTouchMove: () => true
      });

      // Focus first link on menu open
      const firstNavEl = jQuery(this.elements.navigation.find('.menu-item a').first());
      setTimeout(() => firstNavEl.trigger('focus'), 200);
    } else {
      window.subMenuNav.closeAllSubmenu();
      bodyScrollLock.enableBodyScroll(this.elements.navigation); // eslint-disable-line no-undef
    }
  }
}
jQuery(document).ready(() => {
  window.mobileMenu = new MobileMenu();
});
"use strict";

class RiversModal {
  page = null;
  modal = null;
  modalId = '';
  trigger = null;
  closeButton = null;
  isOpen = false;
  focusTrap = null;
  constructor(element) {
    this.grabElements(element);
    if (this.validateElements()) {
      this.bindEvents();
    }
  }
  grabElements(element) {
    this.modal = element;
    this.page = document.getElementById('page');
    this.modalId = this.modal.id;
    this.trigger = document.getElementById(`${this.modalId}-trigger`);
    this.closeButton = this.modal.querySelector('.rivers-base-modal__close');
  }
  validateElements() {
    let isValid = true;
    if (!this.modalId) {
      console.error('Modal ID must be present', this.modal);
      isValid = false;
    }
    const modalLabel = this.modal.getAttribute('aria-labelledby');
    if (!modalLabel || !document.getElementById(modalLabel)) {
      console.error('Modal label must be present', this.modal);
      isValid = false;
    }
    if (!this.trigger) {
      console.error('No trigger found for modal element', this.modal);
      isValid = false;
    }
    if (this.trigger && this.trigger.tagName.toLowerCase() !== 'button') {
      console.error('Trigger must be a button', this.trigger);
      isValid = false;
    }
    if (!this.page) {
      console.error('No page wrapper found', this.modal);
      isValid = false;
    }

    // Set Accessibility Properties
    if (this.modal.tagName.toLowerCase() !== 'dialog') {
      this.modal.setAttribute('role', 'dialog');
    }
    this.modal.setAttribute('aria-modal', 'true');
    return isValid;
  }
  bindEvents() {
    this.trigger.addEventListener('click', this.toggleModal.bind(this));
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.closeModal.bind(this));
    }
  }
  toggleModal() {
    if (this.isOpen) {
      this.closeModal();
    } else {
      this.openModal();
    }
  }
  focusModal() {
    const firstFocusableElement = this.modal.querySelector('input, select, textarea, button, object, a, area[href], [tabindex]');
    if (firstFocusableElement) {
      firstFocusableElement.focus();
    } else {
      this.modal.focus();
    }
  }
  openModal() {
    this.modal.classList.add('open');
    this.focusModal();
    this.focusTrap = this.focusModal.bind(this);
    this.page.addEventListener('focusin', this.focusTrap);
    this.isOpen = true;
  }
  closeModal() {
    this.modal.classList.remove('open');
    this.page.removeEventListener('focusin', this.focusTrap);
    this.trigger.focus();
    this.isOpen = false;
  }
}
document.querySelectorAll('.rivers-base-modal').forEach(element => {
  new RiversModal(element);
});
"use strict";

/**
 * File skip-link-focus-fix.js.
 *
 * Helps with accessibility for keyboard only users.
 *
 * Learn more: https://git.io/vWdr2
 */

class SkipLinkFocusFix {
  constructor() {
    this.browsers = {
      isWebkit: navigator.userAgent.toLowerCase().indexOf('webkit') > -1,
      isOpera: navigator.userAgent.toLowerCase().indexOf('opera') > -1,
      isIe: navigator.userAgent.toLowerCase().indexOf('msie') > -1
    };
    this.bindEvents();
  }
  bindEvents() {
    if ((this.browsers.isWebkit || this.browsers.isOpera || this.browsers.isIe) && document.getElementById && window.addEventListener) {
      window.addEventListener('hashchange', () => {
        const id = window.location.hash.substring(1);
        if (!/^[A-z0-9_-]+$/.test(id)) {
          return;
        }
        const element = document.getElementById(id);
        if (element) {
          if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName)) {
            element.tabIndex = -1;
          }
          element.focus();
        }
      }, false);
    }
  }
}
window.skipLinkFocusFix = new SkipLinkFocusFix();
"use strict";

/**
 * sub-menu-nav.js
 *
 * Handles toggling the sub menus
 */

class SubMenuNav {
  constructor() {
    this.elements = null;
    this.grabElements();
    if (this.elements.subMenuToggle.length) {
      this.bindEvents();
    }
  }
  grabElements() {
    this.elements = {
      window: jQuery(window),
      body: jQuery('body'),
      navigation: jQuery('.main-navigation'),
      subMenuToggle: jQuery('.js-submenu-trigger').not('.menu-item-button--close'),
      parent: jQuery('.menu-item-has-children'),
      subMenu: jQuery('.js-sub-menu'),
      subMenuBack: jQuery('.js-submenu-trigger.menu-item-button--close')
    };
  }
  bindEvents() {
    this.elements.subMenuToggle.on('click', this.handleSubMenu.bind(this));
    this.elements.subMenuBack.on('click', this.handleSubMenuBack.bind(this));
    this.elements.body.on('keyup', this.closeSubmenuOnEsc.bind(this));
    this.elements.window.on('load', this.checkSubmenuHover.bind(this));
    this.elements.window.on('resize', this.checkSubmenuHover.bind(this));
  }
  checkSubmenuHover() {
    // Only handle submenu hover on desktop
    if (this.elements.window.width() >= 1200) {
      this.elements.parent.on('mouseenter', e => {
        e.preventDefault();
        const target = jQuery(e.currentTarget);
        const trigger = jQuery(target.find(this.elements.subMenuToggle));
        const submenu = jQuery(target.find(this.elements.subMenu));
        this.updateAriaAttrs(trigger, submenu);
      });
      this.elements.parent.on('mouseleave', () => this.closeAllSubmenu());
    } else {
      this.elements.parent.off('mouseenter');
      this.elements.parent.off('mouseleave');
    }
  }
  updateAriaAttrs(trigger, submenu) {
    trigger.attr('aria-expanded', 'true');
    submenu.attr('aria-hidden', 'false');
  }
  handleSubMenu(e) {
    e.preventDefault();
    const target = jQuery(e.currentTarget);
    const parent = jQuery(target.closest(this.elements.parent));
    const submenu = jQuery(parent.find(this.elements.subMenu));
    const backlink = jQuery(submenu.find(this.elements.subMenuBack));
    if (parent.hasClass('active')) {
      this.closeAllSubmenu();
    } else {
      this.closeAllSubmenu();
      parent.addClass('active');
      this.elements.navigation.addClass('submenu-open');
      this.updateAriaAttrs(target, submenu);
      setTimeout(() => backlink.trigger('focus'), 200);
    }
  }
  closeAllSubmenu() {
    this.elements.navigation.removeClass('submenu-open');
    this.elements.parent.removeClass('active');
    this.elements.subMenuToggle.attr('aria-expanded', 'false');
    this.elements.subMenu.attr('aria-hidden', 'true');
  }
  closeSubmenuOnEsc(e) {
    if (e.key === 'Escape' && this.elements.navigation.hasClass('submenu-open')) {
      this.closeAllSubmenu();
    }
  }
  handleSubMenuBack(e) {
    this.handleSubMenu(e);
    const target = jQuery(e.currentTarget);
    const parent = jQuery(target.closest(this.elements.parent));
    const subMenuToggle = jQuery(parent.find(this.elements.subMenuToggle));
    setTimeout(() => subMenuToggle.trigger('focus'), 200);
  }
}
jQuery(document).ready(() => {
  window.subMenuNav = new SubMenuNav();
});
